var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationObserver',{ref:"validation"},[_c('DatePicker',{staticClass:"mb-3",attrs:{"label":_vm.label,"maxDate":_vm.allowedDate,"validateName":"conducted","input-value":_vm.compliance.documentValidFromDate,"showValidationErrors":_vm.showValidationErrors,"required":"","isDark":""},on:{"onChange":_vm.setConductedDate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }